
import Env from '../base/env.js';
import Channels from '../base/channels.js';
import lozad from 'lozad'
import Launcher from '../view/launcher'
import LocomotiveScroll from 'locomotive-scroll';
import MainnavTouch from '../ui/MainnavTouch'
import UISwitcher from '../ui/UISwitcher'
import gsap from 'gsap'
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

class UI
{
    constructor()
    {
      const getController = Env.framework.toolbox.getController()
      this.DOM = {
        locoScroll : document.querySelector('[data-scroll-container]')
      }
      this.locoScroll = false
      if(typeof history.scrollRestoration != 'undefined') {
          history.scrollRestoration = 'manual';
      }
      this.launcher = new Launcher()
      this.uiSwitch =  new UISwitcher()
      this.mainnav = new MainnavTouch()
      this.detectAppHeight()
      this.resetEnv();
      setTimeout(() => {
        this.makeScroll()
      }, 200);
      setTimeout(() => {
        this.stickyNav()
        if(getController == 'home') {
          this.anchorsNav()
        }
      }, 250);

    }

    appHeight()
    {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }

    anchorsNav()
    {
      const $anchors = document.querySelectorAll('.jsAnchor')
      for(let $anchor of $anchors)
      {
        $anchor.addEventListener('click',(e)=>{
          const getAnchor = $anchor.getAttribute('href').split('#')[1]
          const nameTarget = '#'+getAnchor+'-section'
          const $target = document.querySelector(nameTarget);
          const offset = (getAnchor == '#contact-us')?-130:0;
          Env.locoScroll.scrollTo($target, { offset:offset});
          if(Env.mobileCSS == true)
          {
            this.mainnav.close(()=>{
              console.log('close');
            })
          }
          e.preventDefault()
          e.stopPropagation()
          return false;
        })
      }
    }

    detectAppHeight()
    {
      this.appHeight()
      Channels.on('window::smartresize',this.appHeight)
    }

    lazy()
    {
      const observer = lozad(); // lazy loads elements with default selector as '.lozad'
      observer.observe();
    }

    makeScroll()
    {
      Env.locoScroll = new LocomotiveScroll({
        el: this.DOM.locoScroll,
        smooth: true,
        lerp:.15
      });
      Env.locoScroll.on('call', (fn) =>{
        Env.framework.UI[fn]()
      })
      Env.locoScroll.on("scroll", ScrollTrigger.update);
      ScrollTrigger.scrollerProxy(this.DOM.locoScroll, {
        scrollTop(value) {
          return arguments.length ? Env.locoScroll.scrollTo(value, 0, 0) : Env.locoScroll.scroll.instance.scroll.y;
        },
        getBoundingClientRect() {
          return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
        },
        pinType: document.querySelector(".smooth-scroll").style.transform ? "transform" : "fixed"
      });
      ScrollTrigger.addEventListener("refresh", () => Env.locoScroll.update());
      ScrollTrigger.refresh();
    }

    stickyNav()
    {
      this.stUI = ScrollTrigger.create({
        trigger: this.DOM.locoScroll,
        start: `top top-=200px`,
        scroller: this.DOM.locoScroll,
        pin: false,
        markers: false,
        onEnter:()=>{
          Env.$html.classList.add('ui--sticky')
        },
        onEnterBack:()=>{
          console.log('enter back');

        },
        onLeave:()=>{
          console.log('leave');
        },
        onLeaveBack:()=>{
          Env.$html.classList.remove('ui--sticky')
        }
      });
    }

    refreshScroll()
    {
      setTimeout(() => {
        if(typeof this.locoScroll != 'undefined') {
          console.log('refresh scroll');
          Env.locoScroll.update()
        }
      }, 200);
    }

    resetEnv()
    {
      Channels.on('statechange::before',function()
      {

      })
      Channels.on('statechange::ready',(current,old,container)=>
      {
          // Env.$html.classList.remove('skin--isWhite')
          Env.$html.classList.remove('ui-dark')
          // Env.$mainNav.classList.remove('is--active');
          // Env.$html.classList.remove('mainnav--isOpened')
        })
    }
}

export default UI;
